export enum CandidateNavigation {
  Summary = 0,
  PayPackages = 7,
  PersonalInformation = 8,
  VirtualInterview = 9
}
